<template>
    <div style="background:white; height:100%">
        <div style="display:flex;line-height:25px ;  "> 
            <div  class="oneMenu" @click="tabClick('one')">
                <div style="margin-left:0px" :class="{tabact: tabitem==='one'}" >
                    <i class="iconfont icon-huizong" style="margin-left:4px;margin-right:5px"></i>工作任务汇总</div> 
            </div>
            <div  class="oneMenu" @click="tabClick('two')">
                <div style="margin-left:40px" :class="{tabact: tabitem==='two'}" >
                    <i class="iconfont icon-a-baobiaoguanlibaobiao" style="margin-left:4px;margin-right:5px"></i>待跟进任务明细</div> 
            </div>
        </div> 
        <div v-if="tabitem=='two'"><list-item v-bind:subHeight="dtlHeight"></list-item></div>
        <div v-show="tabitem=='one'">
            <div style=" display:flex; min-width:1200px; background:#fff;line-height:30px; border-bottom:2px solid #389;">
                <div style="display:flex;padding-top:3px">
                    <div style="width:70px ; " >
                        <i class="iconfont icon-xinzeng" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                        <el-link :disabled="addBool" @click="addRec" :underline="false" ><span style="font-size:12px;margin-right:15px;font-weight:600">新增 </span></el-link>
                    </div>
                    <span style="line-height:32px;font-size:12px;margin-right:5px">进度状态</span>
                    <el-select @change="qryTabData" size="small" v-model="v_status"   placeholder="请选择" style="width:110px">
                        <el-option label="未完成" value="NOTOK" style="color:red"></el-option>
                        <el-option v-for="(item,index) in weekArr" :key="index" :label="item['CNAME']" :value="item['CODE']"></el-option>
                    </el-select>
                    <span style="line-height:32px;font-size:12px;margin-right:5px;margin-left:20px">与我相关的任务</span>
                    <el-checkbox class="large-checkbox" @change="qryTabData" size="larger" v-model="v_self" true-label="Y" false-label="N"  ></el-checkbox>
                    <span style="line-height:32px;font-size:12px;margin-right:5px;margin-left:30px">周</span>
                    <el-date-picker    @change="newDateWeekHandle" @clear="dateClear" size="small" type="week"  v-model="v_week"   :picker-options="{firstDayOfWeek:1}"  format="yyyy 第 WW 周" value-format="yyyy-MM-dd"  style="width:146px; " ></el-date-picker>   
                    <span style="line-height:32px;font-size:12px; margin-left:8px">字段</span>
                    <el-select v-model="selparam"  placeholder="请选择列名" clearable size="small" style="width:130px;margin-left:5px; ">
                        <span v-for="item in tabArr" :key='item.key'>
                            <el-option :label="item.title" :value="item.key" v-if="item.thide=='N'"></el-option>
                        </span>
                    </el-select>
                    <el-select v-model="oper"  size="small" style="width:90px; ">
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO" ></el-option>
                        </span>
                    </el-select>
                    <el-input placeholder="请输入查询值" clearable  v-model="txtparam" size="small" @keyup.enter.native="qryTabData" style="width:180px;   ">
                        <el-button size="small" slot="append" icon="el-icon-search" @click="qryTabData" style="color:#409eff"></el-button>
                    </el-input> 
                </div>
            </div> 
            <el-table  :data="tabData" 
                    border                            
                    disabled-hover
                    v-loading="t_loading"
                    element-loading-text="加载中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(255, 251, 255, 0.8)"
                    style="overflow:auto;margin-top:1px;"
                    size="small"
                    :cell-style="{padding:'3px','font-size':'12px',color:'black'}"
                    :height="tabHeight"              
                    ref="tabref" 
                    :row-key="getRowKey"
                    default-expand-all
                    :tree-props="{children: 'children', hasChildren: 'hasChildren'}" 
                    @row-click="rowClick"
                    :row-class-name="tabRowClass"
                    class="custom-table-border"
                    highlight-current-row>
                <el-table-column label="序号" type="index" width="55"></el-table-column>
                <el-table-column label="任务单号" prop="idno" :min-width="140" :show-overflow-tooltip="true" align="left" >
                    <template slot-scope="scope"><span @click="logShow(scope.row)" style="border-bottom:1px solid red;font-size:11px;cursor:pointer ">{{scope.row['idno']}}</span></template>
                </el-table-column>
                <el-table-column  v-for="(item,index ) in tabArr.filter(item=>item.thide=='N'&&item.key!=='idno')" :key="index"
                    :prop="item.key"
                    :label="item.title"
                    show-overflow-tooltip
                    :align="item.align"                                
                    :sortable="item.edcss!=='checkbox'&&item.sortable=='N'"
                    :min-width="item.width">
                    <template slot-scope="scope">
                        <el-link @click="attView(scope.row)" v-if="item.key=='isatt' && scope.row[item.key]=='Y'" :underline="false"><span style="border-bottom:1px solid red;font-size:11px">附件</span></el-link>                    
                        <el-link @click="seePrd(scope.row[item.key])" v-else-if="item.key=='matno'" :underline="false"><span style="border-bottom:1px solid red;font-size:11px">{{scope.row[item.key]}}</span></el-link>                            
                        <el-link @click="repShow(scope.row )" v-else-if="item.key=='refidno'" :underline="false"><span style="border-bottom:1px solid red;font-size:11px">{{scope.row[item.key]}}</span></el-link> 
                        <el-link @click="seeWkno(scope.row)" v-else-if="item.key=='refwkno'" :underline="false"><span style="border-bottom:1px solid red;font-size:11px">{{scope.row[item.key]}}</span></el-link>   
    
                        <el-popover placement="top-start" title="说明" v-else-if="item.key=='tasktynm'" width="350" trigger="hover">
                            <p style="color:#409eef;font-weight:700;font-size:13px"> {{scope.row['tasktitle']}}</p>                         
                            <span slot="reference"><span style="border-bottom:1px solid red">{{scope.row[item.key]}}</span></span>
                        </el-popover> 
                        <span v-else-if="item.key=='stfgnm'">
                            <el-tag v-if="scope.row['stfg']=='NO'" size="mini" type="info" effect="dark">{{scope.row[item.key]}}</el-tag>
                            <el-tag v-else-if="scope.row['stfg']=='OK'" size="mini" type="success" effect="dark">{{scope.row[item.key]}}</el-tag>
                            <el-tag v-else-if="scope.row['stfg']=='PEND'" size="mini" type="primary" effect="dark">{{scope.row[item.key]}}</el-tag>
                            <el-tag v-else size="mini" type="danger" effect="dark">{{scope.row[item.key]}}</el-tag>
                        </span>
                        <el-progress v-else-if="item.key=='pct'" :text-inside="true" :stroke-width="22" :percentage="Number(scope.row['pct'])"  style="color:red"></el-progress> 
                        <span v-else-if="item.key=='stfg'" size="small"   >{{scope.row['STFGNM']}} </span>
                        <div v-else v-text="item.key=='isatt'?'':scope.row[item.key]" style="float:left;text-overflow:ellipsis;overflow: hidden;white-space:nowrap;width:100%;text-align:left"> </div>
                    </template>
                </el-table-column>
                <el-table-column
                    fixed="right"
                    label="操作"
                    align="center"
                    width="215">
                    <template slot-scope="scope">
                        <i class="iconfont icon-xinzeng" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                        <el-link :disabled="editBool" @click="addSub(scope.row ,scope.$index)" :underline="false"  ><span style="font-size:11px;margin-right:5px;">子任务 </span></el-link>
                        <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                        <el-link   @click="editRec(scope.row,scope.$index,'Y')" :underline="false"  ><span style="font-size:11px;margin-right:5px;">查看 </span></el-link>
                        <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                        <el-link :disabled="addBool" @click="editRec(scope.row,scope.$index,'N')" :underline="false"  ><span style="font-size:11px;margin-right:5px;">编辑 </span></el-link>
                        
                        <i class="iconfont icon-shanchu" style="color:#409EFF;font-size:12px; "></i>
                        <el-link :disabled="addBool" @click="recSet(scope.row,scope.$index )" :underline="false" ><span style="font-size:11px; ">作废</span></el-link>
                    </template>
                </el-table-column>                      
            </el-table>  
            <!-- <div style="margin-top:2px; overflow: hidden;display:flex;background:white;font-size:11px;line-height:30px;width:1000px">
                <div style=" margin-left:20px;font-size:12px;width:530px;font-weight:600;line-height:30px"> 
                    颜色说明：1、未开始：<span style="color:#808080">灰色</span>  2、进行中：<span style="color:blue"> 蓝色</span>  3、逾期：<span style="color:red"> 红色</span>  4、已完成：<span style="color:green"> 绿色</span>  5、终止：<span style="color:black">黑色</span> 
                </div>
            </div>  -->
            <div style="display:flex;line-height:25px ;  "> 
                <div  class="oneMenu" @click="itemClick('one')">
                    <div style="margin-left:0px" :class="{active: actitem==='one'}" >
                        <i class="iconfont icon-a-baobiaoguanlibaobiao" style="margin-left:4px;margin-right:5px"></i>任务跟进日志</div> 
                </div>
                <div  class="oneMenu" @click="itemClick('two')">
                    <div style="margin-left:40px" :class="{active: actitem==='two'}" >
                        <i class="iconfont icon-fenzhijiedian" style="margin-left:4px;margin-right:5px"></i>任务节点明细</div> 
                </div>
            </div> 
            <div v-show="actitem=='one'">
                <el-table  :data="dtlData" 
                    border                            
                    size="small"
                    v-loading="v_loading"
                    element-loading-text="加载中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(255, 251, 255, 0.8)"
                    ref="reflog"
                    :cell-style="{padding:'3px','font-size':'12px',color:'black'}"
                    :header-cell-style="headStyle"
                    header-cell-class-name="clearPadding"
                    style="min-height:100px;margin-top:2px "
                    height="195px"          
                    class="custom-table-border"      
                    highlight-current-row > 
                    <el-table-column label="序号" type="index" width="60"></el-table-column>
                    <el-table-column v-for="(item ,index) in dtlCol.filter(item=>item.thide=='N')" :key="index"  
                        :prop="item.key"
                        :label="item.title"
                        :show-overflow-tooltip="false"
                        :align="item.align"  
                        :min-width="item.width">
                        <template slot-scope="scope">   
                            <el-tag v-if="item.key=='STFG'" size="small" :type='customColorMethod(scope.row[item.key])'  >{{scope.row['STFGNM']}} </el-tag>  
                            <el-link @click="attClick(scope.row)" v-else-if="item.key=='ATTCNT' &&scope.row['ATTCNT']>0" :underline="false" style="font-size:12px;color:red;font-weight:600">查看</el-link>
                            <el-link v-else-if="item.key=='ATTCNT' &&scope.row['ATTCNT']==0" :underline="false" style="font-size:12px;color:red;font-weight:600"> </el-link>
                            <span  v-else v-text="scope.row[item.key]"></span>
                        </template> 
                    </el-table-column>                       
                </el-table> 
            </div>
            <div v-show="actitem=='two'">
                <div class="one-div" style="height:32px;">
                    <span class="oneRow"> 任务拆解明细</span> 
                    <el-button :disabled="saveFlag" @click="nodeAdd" type="primary" plain size="mini" style="height:25px;margin-top:3px;margin-left:20px;border:1px solid green">
                        <i class="iconfont icon-xinzeng" style=" font-size:12px;margin-right:3px;margin-left:-6px;margin-top:2px"></i>新增
                    </el-button>
                </div>
                <el-table  :data="nodeData" 
                    border                            
                    size="small"
                    ref="refnode"
                    :cell-style="{padding:'3px','font-size':'12px',color:'black'}"
                    :header-cell-style="headStyle"
                    header-cell-class-name="clearPadding"
                    style="min-height:100px;margin-top:-9px "
                    height="168px"          
                    class="custom-table-border"      
                    highlight-current-row > 
                    <el-table-column label="序号" type="index" width="60"></el-table-column>
                    <el-table-column v-for="(item ,index) in nodeCol.filter(item=>item.thide=='N')" :key="index"  
                        :prop="item.key"
                        :label="item.title"
                        show-overflow-tooltip 
                        :align="item.align"  
                        :min-width="item.width">
                        <template slot-scope="scope">   
                            <el-tag v-if="item.key=='STFG'" size="small" :type='customColorMethod(scope.row[item.key])'  >{{scope.row['STFGNM']}} </el-tag>  
                            <el-checkbox class="large-checkbox" v-else-if="item.edcss=='checkbox'" disabled  v-model="scope.row[item.key]" true-label="Y" false-label="N"  ></el-checkbox>
                            <span  v-else v-text="scope.row[item.key]"></span>
                        </template> 
                    </el-table-column>    
                    <el-table-column
                        fixed="right"
                        label="操作"
                        align="center"
                        width="120">
                        <template slot-scope="scope">
                            <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                            <el-link :disabled="editBool" @click="editNode(scope.row,scope.$index )" :underline="false"  ><span style="font-size:12px;margin-right:8px;">编辑 </span></el-link>  
                            <i class="iconfont icon-shanchu1" style="color:#409EFF;font-size:12px;margin-right:5px; "></i>
                            <el-link :disabled="delBool" @click="delNode(scope.row,scope.$index )" :underline="false" ><span style="font-size:12px; ">删除</span></el-link>
                        </template>
                    </el-table-column>                     
                </el-table> 
            </div>
        </div>
        <el-dialog class="pub_dialog" v-dialogDrag :show-close="false" :visible.sync="drawer" width="1200px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <div v-for="(gpitem,gpind) in formArr" :key="gpind"  >
                    <div style="border-left:3px solid #409eff;background:#808695;line-height:30px;width:100%;color:#fff;height:32px;padding-left:5px;margin-bottom:8px;font-size:14px;font-weight:600">{{gpitem.gpnm}} </div>
                    <Form :model="perRow" :label-width="120" label-position="right" inline  :rules="ruleValidate">  
                        <span v-for="(item,index) in gpitem.gplist" :key="index" >
                            <FormItem  :label="item.FLDNM"  :class="item.EDCSS=='textarea'?'item-width2': 'item-width'" :prop="item.FLDNO"  v-if="item.FHIDE==='N'">                  
                                <el-select :disabled ="saveFlag" @change="tyClear"  v-if="item.key=='REFIDTY' " v-model="perRow[item.FLDNO]" @clear="tyClear"  placeholder="请选择"  clearable size="medium" style="width:100% ">
                                    <span v-for="(item,index) in tyArr" :key='index' >
                                        <el-option :label="item.CNAME" :value="item.CODE" ></el-option>
                                    </span>
                                </el-select>
                                <el-select  :disabled ="saveFlag" size="medium" v-model="perRow[item.FLDNO]" :clearable="false" v-else-if="item.FLDNO=='STFG' " style="width:100%">
                                    <el-option v-for="(item,index) in weekArr" :key="index" :label="item['CNAME']" :value="item['CODE']"></el-option>
                                </el-select>
                                <el-input-number :disabled ="saveFlag"  :min="0" :max="100" v-else-if="item.FLDNO=='PCT'||item.FLDNO=='LVL'" size="medium" v-model="perRow[item.FLDNO]" style="width:100%"> </el-input-number> 
                                <el-checkbox size="medium" border v-else-if="item.EDCSS==='checkbox'" true-label="Y"  false-label="N" v-model="perRow[item.FLDNO]" style="width:100%"></el-checkbox> 
                                <el-date-picker :disabled ="saveFlag" type="date" size="medium" v-else-if="item.EDCSS==='date'" v-model="perRow[item.FLDNO]" :clearable="false" value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>  
                                <el-select clearable  size="medium" :disabled="saveFlag" v-else-if="item.EDCSS==='select'" v-model="perRow[item.FLDNO]"  filterable  style="width:100%">
                                    <el-option v-for="(item,index) in empArr" :key="index" :label="item.USERNM" :value="item.USERNO"></el-option>
                                </el-select>
                                <el-select clearable  size="medium" :disabled="saveFlag" v-else-if="item.FLDNO==='TASKTY'" v-model="perRow[item.FLDNO]"  filterable  style="width:100%">
                                    <el-option v-for="(item,index) in ordArr" :disabled="item.CODE=='414833'" :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                                </el-select>
                                <el-input type="textarea" resize="none" :rows="3" v-model="perRow[item.FLDNO]" placeholder="请输入" v-else-if="item.EDCSS=='textarea'" style="width:100%"></el-input>
                                <el-input :disabled ="saveFlag" clearable @clear="clrBtn(item.FLDNO)" @focus="inputBtn(item.FLDNO)"   v-else-if="item.EDCSS=='button'" size="medium" v-model="perRow[item.FLDNO]" style="width:100%;border:1px solid #389"> </el-input>  
                                <el-input size="medium" type="text" v-else :disabled="item.DISABLED==='Y'?true:false||saveFlag "  v-model="perRow[item.FLDNO]"></el-input>
                            </FormItem>
                        </span>
                    </Form>
                </div>
                <div style="border-left:3px solid #409eff;background:#808695;line-height:30px;width:100%;height:32px;padding-left:5px;margin-bottom:8px;font-size:14px;font-weight:600;color:#fff">
                    附件明细
                    <el-button :disabled="saveFlag" @click="imgAdd" type="primary" plain size="mini" style="height:25px;margin-top:3px;margin-left:20px;border:1px solid green">
                        <i class="iconfont icon-xinzeng" style=" font-size:12px;margin-right:3px;margin-left:-6px"></i>新增
                    </el-button>
                </div>
                <el-table  :data="attData" 
                    border                            
                    size="small"
                    cell-class-name="clearPadding"                  
                    :header-cell-style="{ 'color':'#389','text-align':'center'}"
                    :cell-style="{padding:'3px',color:'black','font-size':'12px'}"
                    :row-class-name="attRowClass" 
                    :min-height="240" 
                    :row-key="getAttKey"
                    class="custom-table-border"
                    ref="refatt"
                    highlight-current-row
                    style="overflow:auto;margin-top:-8px;"> 
                    <el-table-column label="序号" type="index" width="60"  ></el-table-column>
                    <el-table-column   v-for="(item,index ) in attCol.filter(item=>item.thide=='N') " :key="index"
                        :prop="item.key"
                        :label="item.title"
                        show-overflow-tooltip
                        :align="item.align"  
                        :fixed="item.fix=='Y'" 
                        resizable                              
                        :sortable="item.sortable=='N'&&item.edcss!=='checkbox'"
                        :min-width="item.width">                       
                        <template slot-scope="scope">
                            <span v-if ="saveFlag" >
                                <el-link v-if="item.key=='FILEPATH' " :underline="false"  >                                     
                                    <el-image fit="scale-down"  style="width:100%;height:40px;" :src="scope.row[item.key]" :preview-src-list="[scope.row[item.key]]">                 
                                        <div   slot="error" >
                                            <div v-if="scope.row[item.key] &&(scope.row[item.key]).lastIndexOf('.pdf')>-1" style="width:100%;height:50px;border:1px solid #e8eaec;overflow-y:hidden">
                                                <iframe :src="scope.row[item.key]" frameborder="0" style="width: 100%; height: 100%"></iframe>
                                            </div>
                                            <div v-else>
                                                <span style="color:red;font-weight:700;font-size:14px">附件名称：{{scope.row['FILENM']}}</span>
                                            </div>
                                        </div>
                                    </el-image>
                                </el-link>
                                <span v-else v-text="scope.row[item.key]"></span> 
                            </span>
                            <span v-else >                    
                                <el-date-picker size="mini" type="date"  v-if="item.edcss==='date'" v-model="scope.row[item.key]"   value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                                <el-link v-else-if="item.key=='FILEPATH' " :underline="false"  > 
                                    <el-image v-if="!!scope.row[item.key]" fit="scale-down"  style="width:100%;height:40px;" :src="scope.row[item.key]" :preview-src-list="[scope.row[item.key]]">                 
                                        <div   slot="error" >
                                            <div  v-if="scope.row[item.key] &&(scope.row[item.key]).lastIndexOf('.pdf')>-1" style="width:100%;height:50px;border:1px solid #e8eaec;overflow-y:hidden">
                                                <iframe :src="scope.row[item.key]" frameborder="0" style="width: 100%; height: 100%"></iframe>
                                            </div>
                                            <div v-else>
                                                <span style="color:red;font-weight:700;font-size:14px">附件名称：{{scope.row['FILENM']}}</span>
                                            </div>
                                        </div>
                                    </el-image>
                                    <Upload v-else
                                        ref="upload"
                                        name="upfile"
                                        :data="uploadData"
                                        :show-upload-list="false"
                                        :before-upload="beforeImgFile"
                                        :on-success="successImgFile"
                                        :with-credentials="true"                            
                                        :max-size="10240"
                                        :on-format-error="handleFormatError"
                                        :on-exceeded-size="handleMaxSize"
                                        type="drag"                      
                                        :on-progress="handleProgress"
                                        :action="uploadUrl"
                                        style="display: inline-block;width:98% ">                           
                                        <div style="padding: 1px 0;margin-top:10px">
                                            <el-button size="small" @click="upClick(scope.row,scope.$index)" type="primary">点击上传</el-button>
                                        </div>                                                       
                                    </Upload>     
                                </el-link> 
                                <el-select filterable  v-else-if="item.key=='FILETY'" size="mini" v-model="scope.row[item.key]" style="width:100%"> 
                                    <el-option  v-for="(item,index) in fileTy" :key="index" :label="item.CNAME" :value="item.CNAME"></el-option>
                                </el-select>     
                                <el-input type="text"  v-else-if="item.disabled=='N'" size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-input> 
                                <span v-else v-text="scope.row[item.key]" ></span>
                            </span>    
                        </template>           
                    </el-table-column>  
                    <el-table-column
                        fixed="right"
                        label="状态操作"
                        align="center"
                        width="115">
                        <template slot-scope="scope">
                            <i class="iconfont icon-shanchu1" style="color:#409EFF;font-size:12px;margin-right:2px;"></i>
                            <el-link :disabled="saveFlag"  @click="imgDel(scope.row, scope.$index)" :underline="false" style="font-size:12px; "><span style="font-size:12px;margin-right:10px">删除</span></el-link>  
                            <i class="iconfont icon-xiazai" style="color:#409EFF;font-size:12px;margin-right:2px;"></i>
                            <el-link  @click="downFile(scope.row['FILEPATH'])" :underline="false" style="font-size:12px; "><span style="font-size:12px;margin-right:10px">下载</span></el-link>
                            <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:2px;"></i>
                            <el-link  @click="imgPreview(scope.row['FILEPATH'])" :underline="false" style="font-size:12px; "><span style="font-size:12px;margin-right:5px">PDF预览</span></el-link>
                        </template>
                    </el-table-column>
                </el-table>
 
                <div v-if="v_action !=='Y'" style="display:flex;margin-top:5px;" >                  
                    <div style="display:flex;margin-left:30px;min-height:200px;flex-wrap:wrap"  >
                        <div v-if="FILEPATH" style="border:1px solid #ccc;height:183px ;width:200px;margin-right:30px;">  
                            <div v-if="FILEPATH &&FILEPATH.lastIndexOf('.pdf')>-1" style="width:200px;height:153px;border:1px solid #e8eaec;overflow-y:hidden">
                                <iframe :src="FILEPATH" frameborder="0" style="width: 100%; height: 100%"></iframe>
                            </div>
                            <el-image v-else fit="fill" :preview-src-list="[FILEPATH]" style="width:200px;height:150px;" :src="FILEPATH">
                                <div slot="error" class="image-slot" style="margin:30px 50px;">
                                    <span style="color:red;font-weight:700;font-size:14px">附件名称：{{FILEPATH}}</span>
                                </div>
                            </el-image>
                            <div style="height:25px;background:#e8eaec;width:200px; display:flex;justify-content:space-between">
 
                                <el-link v-if="FILEPATH.lastIndexOf('pdf')>-1" :underline="false" @click="imgPreview( FILEPATH)"><Icon type="ios-search" /> PDF预览</el-link>
                                <el-link v-else :underline="false"  @click="downFile(FILEPATH)"><i class="iconfont icon-xiazai" style="margin-right:3px"></i>下载</el-link>
                            </div>
                        </div>
                        <div v-if="FILEPATH2" style="border:1px solid #ccc;height:183px ;width:200px;margin-right:30px;"> 
                            <div v-if="FILEPATH2 &&FILEPATH2.lastIndexOf('.pdf')>-1" style="width:200px;height:153px;border:1px solid #e8eaec;overflow-y:hidden">
                                <iframe :src="FILEPATH2" frameborder="0" style="width: 100%; height: 100%"></iframe>
                            </div> 
                            <el-image v-else fit="fill" :preview-src-list="[FILEPATH2]" style="width:200px;height:150px;" :src="FILEPATH2">
                                <div slot="error" class="image-slot" style="margin:30px 50px;">
                                    <span style="color:red;font-weight:700;font-size:14px">附件名称：{{FILEPATH2}}</span>
                                </div>
                            </el-image>
                            <div style="height:25px;background:#e8eaec;width:200px; display:flex;justify-content:space-between">
                                
                                <el-link v-if="FILEPATH2.lastIndexOf('pdf')>-1" :underline="false" @click="imgPreview( FILEPATH2)"><Icon type="ios-search" /> PDF预览</el-link>
                                <el-link v-else :underline="false"  @click="downFile(FILEPATH2)"><i class="iconfont icon-xiazai" style="margin-right:3px"></i>下载</el-link>
                            </div>
                        </div>
                        <div v-if="FILEPATH3" style="border:1px solid #ccc;height:183px ;width:200px;margin-right:30px;">  
                            <div v-if="FILEPATH3 &&FILEPATH3.lastIndexOf('.pdf')>-1" style="width:200px;height:153px;border:1px solid #e8eaec;overflow-y:hidden">
                                <iframe :src="FILEPATH3" frameborder="0" style="width: 100%; height: 100%"></iframe>
                            </div> 
                            <el-image v-else fit="fill" :preview-src-list="[FILEPATH3]" style="width:200px;height:150px;" :src="FILEPATH3">
                                <div slot="error" class="image-slot" style="margin:30px 50px;">
                                    <span style="color:red;font-weight:700;font-size:14px">附件名称：{{FILEPATH3}}</span>
                                </div>
                            </el-image>
                            <div style="height:25px;background:#e8eaec;width:200px; display:flex;justify-content:space-between">
                                
                                <el-link v-if="FILEPATH3.lastIndexOf('pdf')>-1" :underline="false" @click="imgPreview( FILEPATH3)"><Icon type="ios-search" /> PDF预览</el-link>
                                <el-link v-else :underline="false"  @click="downFile(FILEPATH3)"><i class="iconfont icon-xiazai" style="margin-right:3px"></i>下载</el-link>
                            </div>
                        </div>
                        <div v-if="FILEPATH4" style="border:1px solid #ccc;height:183px ;width:200px;margin-right:30px;">  
                            <div v-if="FILEPATH4 &&FILEPATH4.lastIndexOf('.pdf')>-1" style="width:200px;height:153px;border:1px solid #e8eaec;overflow-y:hidden">
                                <iframe :src="FILEPATH4" frameborder="0" style="width: 100%; height: 100%"></iframe>
                            </div> 
                            <el-image v-else fit="fill" :preview-src-list="[FILEPATH4]" style="width:200px;height:150px;" :src="FILEPATH4">
                                <div slot="error" class="image-slot" style="margin:30px 50px;">
                                    <span style="color:red;font-weight:700;font-size:14px">附件名称：{{FILEPATH4}}</span>
                                </div>
                            </el-image>
                            <div style="height:25px;background:#e8eaec;width:200px; display:flex;justify-content:space-between">
                                
                                <el-link v-if="FILEPATH4.lastIndexOf('pdf')>-1" :underline="false" @click="imgPreview( FILEPATH4)"><Icon type="ios-search" /> PDF预览</el-link>
                                <el-link v-else :underline="false"  @click="downFile(FILEPATH4)"><i class="iconfont icon-xiazai" style="margin-right:3px"></i>下载</el-link>
                            </div>
                        </div>
                    </div> 
                </div>

            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                <span style="float:right">
                    <span :style="stfgColor">
                        <i class="iconfont" :class="stfgCss"  style="font-size:30px; margin-left:40px;height:35px;vertical-align:middle"></i>
                    </span>
                    <el-button type="info" @click="drawer=false" size="small"  icon="iconfont icon-shanchu" style="margin-left:50px;">  取消</el-button>
                    <el-button :disabled="saveFlag " @click="saveRec" size="small" type="primary" style="margin-left:30px;" icon="iconfont icon-baocun"  > 保存 </el-button>
                </span>
            </div>
        </el-dialog>
        <!-- 提示框 -->
        <el-dialog v-dialogDrag :visible.sync="promptWin"  width="450px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">提示</span>
            </div>
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <span slot="footer"  >
                <el-button type="primary" size="small" @click="promptWin = false">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 引用选择框 -->
        <el-dialog  v-dialogDrag v-if="btnWin"  :visible.sync="btnWin" :width="selWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">选择记录</span>
            </div> 
            <pub-win ref="refpub" v-bind:tabCol ="tableCol" v-bind:v_cond ="v_cond" v-bind:v_table="v_table" v-bind:v_key2="v_key2" v-bind:v_value2="v_value2" @child-exit="btnWin=false" @child-sure="btnSure"></pub-win>                
        </el-dialog>
        <el-dialog  v-dialogDrag  v-if="oneWin"  :visible.sync="oneWin" :width="selWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">选择记录</span>
            </div> 
            <sel-win v-bind:tabCol ="v_Col" v-bind:v_table="v_table" v-bind:v_key2="v_key2" v-bind:v_value2="v_value2" @child-exit="oneWin=false" @child-sure="oneSure"></sel-win>                
        </el-dialog>
        <!-- 上传进度 -->
        <el-dialog :visible.sync="videoFlag" width="150px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'30px'}">
                <span style="line-height:30px;height:30px;font-size:16px;padding-left:5px;">正在上传中...</span>
            </div>
            <el-progress   type="circle" :percentage="videoUploadPercent"  ></el-progress>  
        </el-dialog>
        <!-- 显示图片-->
        <el-dialog class="pub_dialog" v-dialogDrag :visible.sync="showWin" width="1200" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">附件明细</span>
            </div> 
            <div style="display:flex;margin-top:5px;" >                
                <div style="display:flex;margin-left:30px;height:440px;flex-wrap:wrap"  >
                    <div v-if="FILEPATH" style="border:1px solid #ccc;height:183px ;width:200px;margin-right:30px;">  
                        <div v-if="FILEPATH &&FILEPATH.lastIndexOf('.pdf')>-1" style="width:200px;height:153px;border:1px solid #e8eaec;overflow-y:hidden">
                            <iframe :src="FILEPATH" frameborder="0" style="width: 100%; height: 100%"></iframe>
                        </div>
                        <el-image v-else fit="fill" :preview-src-list="[FILEPATH]" style="width:200px;height:150px;" :src="FILEPATH">
                            <div slot="error" class="image-slot" style="margin:30px 50px;">
                                <span style="color:red;font-weight:700;font-size:14px">附件名称：{{FILEPATH}}</span>
                            </div>
                        </el-image>
                        <div  style="height:25px;background:#e8eaec;width:200px; display:flex;justify-content:space-between">
                            <el-link v-if="FILEPATH.lastIndexOf('pdf')>-1" :underline="false" @click="imgPreview( FILEPATH)"><Icon type="ios-search" /> PDF预览</el-link>
                            <el-link v-else :underline="false"  @click="downFile(FILEPATH)"><i class="iconfont icon-xiazai" style="margin-right:3px"></i>下载</el-link>
                        </div>
                    </div>
                    <div v-if="FILEPATH2" style="border:1px solid #ccc;height:183px ;width:200px;margin-right:30px;"> 
                        <div v-if="FILEPATH2 &&FILEPATH2.lastIndexOf('.pdf')>-1" style="width:200px;height:153px;border:1px solid #e8eaec;overflow-y:hidden">
                            <iframe :src="FILEPATH2" frameborder="0" style="width: 100%; height: 100%"></iframe>
                        </div> 
                        <el-image v-else fit="fill" :preview-src-list="[FILEPATH2]" style="width:200px;height:150px;" :src="FILEPATH2">
                            <div slot="error" class="image-slot" style="margin:30px 50px;">
                                <span style="color:red;font-weight:700;font-size:14px">附件名称：{{FILEPATH2}}</span>
                            </div>
                        </el-image>
                        <div  style="height:25px;background:#e8eaec;width:200px; display:flex;justify-content:space-between">
                            <el-link v-if="FILEPATH2.lastIndexOf('pdf')>-1" :underline="false" @click="imgPreview( FILEPATH2)"><Icon type="ios-search" /> PDF预览</el-link>
                            <el-link v-else :underline="false"  @click="downFile(FILEPATH2)"><i class="iconfont icon-xiazai" style="margin-right:3px"></i>下载</el-link>
                        </div>
                    </div>
                    <div v-if="FILEPATH3" style="border:1px solid #ccc;height:183px ;width:200px;margin-right:30px;">  
                        <div v-if="FILEPATH3 &&FILEPATH3.lastIndexOf('.pdf')>-1" style="width:200px;height:153px;border:1px solid #e8eaec;overflow-y:hidden">
                            <iframe :src="FILEPATH3" frameborder="0" style="width: 100%; height: 100%"></iframe>
                        </div> 
                        <el-image v-else fit="fill" :preview-src-list="[FILEPATH3]" style="width:200px;height:150px;" :src="FILEPATH3">
                            <div slot="error" class="image-slot" style="margin:30px 50px;">
                                <span style="color:red;font-weight:700;font-size:14px">附件名称：{{FILEPATH3}}</span>
                            </div>
                        </el-image>
                        <div  style="height:25px;background:#e8eaec;width:200px; display:flex;justify-content:space-between">
 
                            <el-link v-if="FILEPATH3.lastIndexOf('pdf')>-1" :underline="false" @click="imgPreview( FILEPATH3)"><Icon type="ios-search" /> PDF预览</el-link>
                            <el-link v-else :underline="false"  @click="downFile(FILEPATH3)"><i class="iconfont icon-xiazai" style="margin-right:3px"></i>下载</el-link>
                        </div>
                    </div>
                    <div v-if="FILEPATH4" style="border:1px solid #ccc;height:183px ;width:200px;margin-right:30px;">  
                        <div v-if="FILEPATH4 &&FILEPATH4.lastIndexOf('.pdf')>-1" style="width:200px;height:153px;border:1px solid #e8eaec;overflow-y:hidden">
                            <iframe :src="FILEPATH4" frameborder="0" style="width: 100%; height: 100%"></iframe>
                        </div> 
                        <el-image v-else fit="fill" :preview-src-list="[FILEPATH4]" style="width:200px;height:150px;" :src="FILEPATH4">
                            <div slot="error" class="image-slot" style="margin:30px 50px;">
                                <span style="color:red;font-weight:700;font-size:14px">附件名称：{{FILEPATH4}}</span>
                            </div>
                        </el-image>
                        <div   style="height:25px;background:#e8eaec;width:200px; display:flex;justify-content:space-between">
                            <el-link v-if="FILEPATH4.lastIndexOf('pdf')>-1" :underline="false" @click="imgPreview( FILEPATH4)"><Icon type="ios-search" /> PDF预览</el-link>
                            <el-link v-else :underline="false"  @click="downFile(FILEPATH4)"><i class="iconfont icon-xiazai" style="margin-right:3px"></i>下载</el-link>
                        </div>
                    </div>
                </div> 
            </div>
        </el-dialog>
 
 
        <!-- 明细产品 -->
        <el-dialog class="pub_dialog" v-dialogDrag :visible.sync="prdWin" v-if="prdWin" :width="selWidth" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="4vh"> 
            <prd-see ref="refprd" @child-exit="prdWin=false"></prd-see>          
        </el-dialog>
        <!-- report preview -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="repWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">报表预览</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <iframe :src="repUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
            </div>
        </el-dialog>
        <!-- 明细资料框 -->
        <el-dialog v-dialogDrag  :visible.sync="wkWin"  :width="tabWidth" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body top="3vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">关联单据明细</span>
            </div>
            <div >{{v_wkno}}</div>
        </el-dialog>
        <!-- 链接图片预览 -->
        <el-dialog v-dialogDrag :visible.sync="linkWin" width="1200px" append-to-body :close-on-press-escape="false" :close-on-click-modal="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">预览</span>
            </div>
            <div style="display:flex;width:1150px;flex-wrap:wrap">
                <div v-for="(item,index) in linkArr" :key="index" style="border:1px solid #ccc;height:183px ;width:200px;margin-right:30px; ">    
                    <div v-if="item &&item['FILEPATH'].lastIndexOf('.pdf')>-1" style="width:200px;height:153px;border:1px solid #e8eaec;overflow-y:hidden">
                        <iframe :src="item['FILEPATH']" frameborder="0" style="width: 100%; height: 100%"></iframe>
                    </div>
                    <el-image v-else fit="fill" :preview-src-list="[item['FILEPATH']]" style="width:200px;height:150px;" :src="item['FILEPATH']"></el-image>
                    <div style="height:25px;background:#e8eaec;width:200px; display:flex;justify-content:space-between">
                        <el-link   :underline="false" @click="downFile(item['FILEPATH']) "><i class="iconfont icon-xiazai" style="font-size:12px"> 下载</i> </el-link>
                        <el-link :underline="false" @click="imgPreview( item['FILEPATH'])"><i class="iconfont icon-chakan1" style="font-size:12px"> 预览</i></el-link>
                    </div>
                </div>
            </div>
        </el-dialog>
        <!-- 节点表单 -->
        <el-dialog class="pub_dialog" v-dialogDrag :visible.sync="nodeWin" width="1200px" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;"> 明细资料 </span>
            </div> 
            <Form  :model="v_nodeRow" :label-width="120"  :rules="dtlValidate" label-position="right" inline >
                <span v-for="(item,index) in nodeCol" :key="index" >
                    <FormItem :class=" 'item-width'"  :label="item.title" :prop="item.key" v-if="item.fhide==='N'">                                  
                        <el-select   v-if="item.key==='TASKTY'" v-model="v_nodeRow[item.key]"  style="width:100%">
                            <el-option v-for="(item,index) in taskArr " :key="index" :label="item.CNAME" :value="item.CNAME"></el-option>
                        </el-select>
                        <el-select   filterable v-else-if="item.key==='MATTY'" v-model="v_nodeRow[item.key]"  style="width:100%">
                            <el-option v-for="(item,index) in mattyArr " :key="index" :label="item.CNAME" :value="item.CNAME"></el-option>
                        </el-select>
 
                        <el-checkbox class="large-checkbox" v-else-if="item.edcss=='checkbox'" border v-model="v_nodeRow[item.key]" true-label="Y" false-label="N" style="width:100%" ></el-checkbox>
                        <el-input clearable @clear="clrBtn"  @focus="inputBtn(item.key)" v-else-if="item.edcss=='button'"   v-model="v_nodeRow[item.key]" style="width:100%;border:1px solid #808695"> </el-input>
                        <el-date-picker type="date"  v-else-if="item.edcss==='date'" v-model="v_nodeRow[item.key]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>    
                        <el-select clearable   v-else-if=" item.key=='SALER'" v-model="v_nodeRow[item.key]"  filterable  style="width:100%">
                            <el-option v-for="(item,index) in empArr" :key="index" :label="item.USERNM" :value="item.USERNM"></el-option>
                        </el-select>
                        <el-input :placeholder="item.holder" type="text" v-else  :disabled="item.disabled=='Y'?true:false" v-model="v_nodeRow[item.key]"></el-input>
                    </FormItem>
                </span>
            </Form>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                <span style="float:right">
                    <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="nodeWin=false" style="margin-right:25px;">取消</el-button>
                    <el-button type="primary" size="small" icon="iconfont icon-chenggong1" :disabled="nodeFlag" @click="nodeSave" style="margin-right:10px;">确定</el-button>
                </span>
            </div>
        </el-dialog>
    </div>  
</template>
<script>
import { getDate } from '@/api/Select';
import pubWin from '../datamgt/pubmulti.vue'  
import selWin from '../datamgt/pubwin.vue' 
import { getTabColOrData,getBaseData } from '../../api/user';
import prdSee from '../prdmgt/prd_see.vue'
import FileSaver from 'file-saver'
import listItem from './wait_work.vue'
 
//局部注册
export default {
    name:"job_plan",
    data () {
        return {
            nodeFlag:false,
            mattyArr:[],
            nodeCol:[],
            empCol:[],
            nodeData:[],
            nodeWin:false,
            v_nodeRow:{},
            t_idseq:'',
            linkWin:false,
            linkArr:[],
            v_wkno:'',
            wkWin:false,
            v_week:'',
            v_loading:false,
            t_loading:false,
            dtlRow:{},
            uploadData:{},
            actitem:'one',
            drawer:false,
            prodCol: [],
            v_saveFlag:true,
            saveFlag:false,
            promptWin:false,
            prompt:'',
            stfgCss:'',
            showWin:false,
            v_radio:'NO',
            stfgColor:'',
            perRow:{},
            tyArr: [],
            ordArr:[],
            v_stfg:'YES', //模块ID集合
            prdWin:false,
            active:'', //二级菜单选中标志
            v_index:0,
            disabled:false, //新增权限制
            chkIndex: 0,
            idseq:'', //菜单主键
            lstseq:'',//菜单主键
            ruleValidate:{},
            formArr:[],
            tabData:[], //表数据
            oneCol:[],
            tabArr:[], //表列
            dtlData:[], // 
            dtlCol:[],
            oper:'like',
            comboArr:{},
            txtparam:'',
            selparam:'todttm',
            txtparam2:'',
            selparam2:'',
            oper2:'like',
            v_usernm:this.$cookies.get('v_usernm'), //api 请求用户
            rowIndex:'-1',
            v_url:'xuper_auth/getTableRecMany', //api请求路径
            v_formurl:'xuper_auth/getFormGroup', 
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') ,//api 请求密码
            v_admin:this.$cookies.get('v_admin') ,//api 请求密码
            dataCount:0,
            rowSize:50,
            goPage:'',
            notNull:[],
            current:1,
            fileTy:[],
            empArr:[],
            stfgBool:true,
            addBool:false, //新增,为true时--禁止
            editBool:false, //编辑,为true时--禁止
            delBool:false, //删除 ,为true时--禁止
            cfmBool:false, //审核 ,为true时--禁止
            cancelBool:false, //作废 ,为true时--禁止
            operArr:[],
            pageList: [ {
                value: 50,
                label: '50'
                }, 
                {
                value: 100,
                label: '100'
            }],
            v_key:'',
            v_action:'N',
            imgData:[],
            v_table:'',
            tableCol :[],
            v_Col:[],
            v_key2 :'',
            v_value2 :'',
            btnWin:false,
            oneWin:false,
            poCol:[],
            ordCol:[],
            newCol:[],
            qcCol:[],
            v_tabrow:{},
            fileName:'',
            FILEPATH:'',
            FILEPATH2:'',
            FILEPATH3:'',
            FILEPATH4:'',
            uploadUrl: '/xuper_oss/ftpUpload_nocheck' ,
            Accept: "png,jpg,jpeg,gif,pdf,doc,docx,xls,xlsx,dxf,csv", //上传文件格式限制
            videoUploadPercent:0,
            videoFlag:false,
            v_row:{},
            delPath:[],
            v_self:'N' ,
            v_status:'NOTOK',
            weekArr:[],
            v_cond:'' ,
            v_imgRow:{},
            v_imgIndex:'',
            v_frdttm:'',
            v_todttm:'',
            repUrl:'',
            repWin:false,
            v_idseq:'',
            planArr:[],
            v_random:'',
            supCol:[],
            attData:[],
            attCol:[],
            dtlValidate:{},
            notDtl:[],
            taskArr:[],
            tabitem:'one',
            selectArr:[],
            v_roleid:'',
        }    
    },
    mounted () { 
        this.showkey()
        //用户表单新增、编辑、审核、作废权限 :frmid:94客户资料ID
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','407458','v_sys_user_priv','').then(res=>{           
            this.v_roleid =res.result[0]['ROLEID']
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISCANCEL==='N'){ //作废
                    this.cancelBool=true
                }
            }
        })  
 
        //操作符
        getBaseData('xuper_auth/getBaseData','PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        })
        getBaseData(this.v_url,'corpid',this.v_corpid,'isout','N','v_sys_user',' and stfg=\'Y\'').then(res=>{
            this.empArr =res.result
            this.selectArr =res.result.map(item=>{
                return {label:item.USERNM,value:item.USERNM}
             })
        })
        getBaseData(this.v_url,'parentno','228812','subno2','WORK','v_SYS_BASE','').then(res=>{
            this.tyArr =res.result
        })
        getBaseData(this.v_url,'parentno','414830','','','v_SYS_BASE','').then(res=>{
            this.ordArr =res.result
        })
        getBaseData(this.v_url,'parentno','474907','','','v_SYS_BASE','').then(res=>{
            this.taskArr =res.result
        })
        getBaseData(this.v_url,'','','','','V_PLAN_STFG','').then(res=>{
            this.weekArr =res.result
        })
        getBaseData(this.v_url,'PARENTNO','474703','','','v_sys_base','').then(res=>{
            this.fileTy =res.result
        })
        getBaseData(this.v_url,'ty','MAT','corpid',this.v_corpid,'bs_type','').then(res=>{
            this.mattyArr =res.result
        })
        //表单资料分组 
        getTabColOrData(this.v_formurl,'v_sys_form_fld','idseq','407458','gpnm,gpsort','','lstseq','4', ' order by gpsort').then((res) => {
            this.formArr = res.result             
        })
        //动态生成表单验证规则
        getTabColOrData(this.v_url,'v_sys_form_fld','idseq','407458','LSTSEQ','4','NOTNULL','Y').then((res) => {
            let ruleObj={}
            let ruleVal=[]
            this.notNull = res.result
            res.result.forEach(item => {
                let v_fldnm =item.FLDNM
                let obj1={required:true,message:v_fldnm+'不能为空'}
                ruleVal =[]
                ruleVal.push(obj1)
                ruleObj[item.FLDNO]=ruleVal                  
            });
            this.ruleValidate =ruleObj
        })
        getTabColOrData(this.v_url,'v_sys_form_fld','idseq','407458','LSTSEQ','6','NOTNULL','Y').then((res) => {
            let ruleObj={}
            let ruleVal=[]
            this.notDtl = res.result
            res.result.forEach(item => {
                let v_fldnm =item.FLDNM
                let obj1={required:true,message:v_fldnm+'不能为空'}
                ruleVal =[]
                ruleVal.push(obj1)
                ruleObj[item.FLDNO]=ruleVal                  
            });
            this.dtlValidate =ruleObj
        })
    },
    computed: {
        dtlHeight: function() {
            return (window.innerHeight - 185) + 'px';
        }, 
        tabHeight: function() {
            return (window.innerHeight - 380) + 'px';
        }, 
        tabWidth: function() {
            return (window.innerWidth - 100) + 'px';
        },
        selWidth: function() {
            return (window.innerWidth - 220) + 'px';
        },
    },
    components: {
        pubWin,
        prdSee,
        selWin,
        listItem,
 
    },
    created () {       
        if (this.v_username){ 
            this.v_idseq =this.$route.query.idseq
            //查询数据
            if (this.v_idseq){
                this.getWkList(' and idseq='+this.v_idseq)
            }else{
                this.qryTabData()
            }
            this.getTabField() //表列字段
           // this.getDateWeek()
        }else{
            let routeUrl = this.$router.resolve({
                path: '/login',
                query: {},
            });
            window.open(routeUrl.href, '_self');
        }
    },
    watch: {
 
    },
    methods: {
        handleChange(val) {
            console.log('选中值：', val)
        },
        delNode(row,index){
            if(row['ADDUSER']!==this.v_usernm ){
                this.prompt='当前操作用户与行记录新增用户不同，请核查'
                this.promptWin =true
            }else{
                this.$confirm('你确定要删除此行记录吗','提示',{
                    confirmButtonText: '确定',
                    cancelButtonText:'取消',
                    customClass:'messageBox',
                    showClose:false,
                    closeOnClickModal:false,
                    closeOnPressEscape:false,
                    type:'info',
                }).then(()=>{
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/delTabRec',
                        data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'BS_PLAN_ITEM',p_key2:'lstseq',p_value2:row.LSTSEQ },
                    }).then(res=>{      
                        if(res.code =='200')  {           
                            this.nodeData.splice(index,1)  
                        }else{
                            this.promptWin=true
                            this.prompt=res.message
                        }        
                    }) 
                    
                }).catch(()=>{})
            }
        },
        editNode(row,index){
            this.nodeWin =true
            this.v_nodeRow =JSON.parse(JSON.stringify(row))
        },
        nodeSave(){
            this.notDtl.some(item=>{  //forEach 没找到跳出循环，some：return true 跳出lop ,every：return false 跳出
                if (!this.v_nodeRow[item.key] ){
                    this.stfgBool =false 
                    this.promptWin=true
                    this.prompt=item.title+'不能为空'
                    return true
                }else{
                    this.stfgBool =true  
                }
            })
            if (this.stfgBool) {
                if (!this.v_nodeRow['ISSMP']&&!this.v_nodeRow['ISDRAW']&&!this.v_nodeRow['ISPO']&&!this.v_nodeRow['ISFIX']&&!this.v_nodeRow['ISTEST']&&!this.v_nodeRow['ISQC']){
                    this.promptWin=true
                    this.prompt= '请至少选择一个任务类型'
                    return
                }
                this.nodeFlag =true
                this.$axios({
                    method: 'post',
                    url: 'xuper_auth/tableBodySave',
                    data: {p_json:JSON.stringify(this.v_nodeRow ), p_table:'BS_PLAN_ITEM',p_idseq:this.t_idseq},
                }).then(res =>{
                    this.nodeWin =false
                    this.nodeFlag =false
                    this.getNodeData(this.t_idseq)
                })
            }
        },
 
        nodeAdd(){
            if (this.t_idseq){
                this.nodeWin =true
                this.v_nodeRow={'STFG':'NO',IDSEQ:this.t_idseq,LSTSEQ:'',ISSMP:'N',ISDRAW:'N',ISPO:'N',ISFIX:'N',ISTEST:'N',ISQC:'N'}                
            }else{
                this.promptWin =true
                this.prompt ='请选择任务行记录'
            }
        },
        itemClick(val){
            this.actitem =val     
        },
        tabClick(val){
            this.tabitem =val     
        },
        imgAdd(){
            let v_row ={}
            this.attCol.forEach(item=>{
                v_row[item.key] =''
            })  
            this.attData.push(Object.assign(v_row,{FILETY:'多媒体文件'}) )
            this.$nextTick(()=>{
                this.$refs['refatt'].doLayout()
            }) 
        },
        upClick(row,index){
            this.v_imgRow =row
            this.v_imgIndex =index
        },
        attClick(row){
            this.linkArr=[]
            this.linkWin =true
            getTabColOrData(this.v_url,'V_mat_img','idseq',row['WKIDSEQ'],'','').then((res) => {              
                if (res){
                    this.linkArr =res.result
                }
            })
        },
        //查询附件数据
        qryImgData(idseq){
            this.attData=[]
            getTabColOrData(this.v_url,'V_mat_img','idseq',idseq,'','').then((res) => {              
                if (res){
                    this.attData =res.result
                }
            })

        },
        //单元格样式
        cellStyle({row,column}){
            if (column.property=='pct' ){
                return {background:'linear-gradient(to right,#2e9bcfcc 0%,#4fcfd5cc '+row.pct+'%'+',transparent 0%) !important',textAlign:'center',padding:'2px'}
            }else{
                return {padding:'4px'}
            } 
        },
        getRowKey(row){
            return row.idseq
        },
        getAttKey(row){
            return row.index
        },
        attRowClass({row,rowIndex}){  //为 table数据添加 index 字段
            row.index =rowIndex
        },
        rowClick(row){
            this.t_idseq =row['idseq']
            this.getdtlData(row['idseq'])
        },
        tabRowClass({row,rowIndex}){  //为 table数据添加 index 字段
            row.index =rowIndex
            // 1、未开始：灰色  2、进行中：蓝色  3、逾期：黄色  4、已完成：绿色  5、终止：黑色
            if (row['stfg']=='NO' &&row['isover']=='N' ){  //未开始
                return 'gray-row';
            }else if (row['stfg'] =='PEND' &&row['isover']=='N'){
                return 'blue-row';
            }else if (row['stfg'] =='OVER' ||row['isover']=='Y' ){
                return 'red-row';
            }else if (row['stfg'] =='OK' ){
                return 'green-row';
            }else if (row['stfg'] =='END' ){
                return 'black-row';
            }
        },
        //状态审核
        recSet(row,index){
            if(row['ADDUSER']!==this.v_usernm && this.v_roleid!=='008' && this.v_username!=='18025667613'){
                this.prompt='当前操作用户与行记录新增用户不同，请核查'
                this.promptWin =true
            }else{
                this.$confirm('你确定要作废此行记录吗','提示',{
                    confirmButtonText: '确定',
                    cancelButtonText:'取消',
                    customClass:'messageBox',
                    showClose:false,
                    closeOnClickModal:false,
                    closeOnPressEscape:false,
                    type:'info',
                }).then(()=>{
                    var vm=this;
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/updateRec',
                        data: {p_key:'idseq',p_value:row.idseq,p_table:'BS_PLAN',p_cond:' set ORDSTFG=\'X\'' },
                    }).then(res=>{      
                        if(res.code =='200')  {           
                        // this.tabData.splice(index,1)  
                            this.qryTabData()  
                        }else{
                            this.promptWin=true
                            this.prompt=res.message
                        }        
                    }) 
                    
                }).catch(()=>{})
            }
        },
        seeWkno(row){
            this.v_wkno=JSON.stringify(row['refwkno'])
            this.wkWin =true
        },
        downFile(path){
            if (path){
                const arr_name=path.split("/")
                const file_name=arr_name[arr_name.length-1] //获取文件名
                FileSaver.saveAs(path,file_name) 
            }else{
                this.promptWin =true
                this.prompt ='没有文件可下载'
            }
        },
        //查看单据
        repShow(row){
            let v_arr =row['refidno'].split(',') ,v_idno='' ,v_rep=''
            let v_idno2='',v_idno3='',v_idno4=''
            v_idno =v_arr[0]
            v_idno2 =v_arr.length==2?v_arr[1]:''
            if (v_arr.length ==3){
                v_idno2 =v_arr[1]
                v_idno3 =v_arr[2]  
            }else if (v_arr.length ==4){
                v_idno2 =v_arr[1]
                v_idno3 =v_arr[2]  
                v_idno4 =v_arr[3] 
            }
            if (row['refidty']=='228813'){
                v_rep ='repsale_view.cpt'
            }else if (row['refidty']=='451336'){ //产品开发建议书
                v_rep ='new_prd.cpt'
            }else{
                v_rep ='rep_poord.cpt'
            }
            this.repWin =true
            this.repUrl =this.$store.state.repUrl+v_rep +'&p_corpid='+row['corpid']+'&p_idno=' +v_idno+'&p_idno2=' +v_idno2+'&p_idno3=' +v_idno3+'&p_idno4=' +v_idno4  
        },
        logShow(row){
            let v_idno =row['idno']
            let v_rep ='job_plan.cpt'
            this.repWin =true
            this.repUrl =this.$store.state.repUrl+v_rep +'&p_corpid='+row['corpid']+'&p_idno=' +v_idno
        },
        //查看产品
        seePrd(idseq){
            this.prdWin =true
            this.$nextTick(()=>{
                this.$refs['refprd'].initData(idseq)
            })
        },
        dateClear(){
            this.v_frdttm=''
            this.qryTabData()
        },
        newDateWeekHandle(){
            const now = new Date(this.v_week);
            const nowTime = now.getTime();
            const day = now.getDay();
            const oneDayTime = 24*60*60*1000;
            const mondayTime = nowTime - (day-1)*oneDayTime;
            const sundayTime = nowTime + (7-day)*oneDayTime;
            this.v_frdttm = this.$moment(mondayTime).format('YYYY-MM-DD');
            this.v_todttm  = this.$moment(sundayTime).format('YYYY-MM-DD');
            //console.log(this.v_frdttm,this.v_todttm)
            this.qryTabData()
        },
        getDateWeek(){
            const now = new Date();
            const nowTime = now.getTime();
            const day = now.getDay();
            const oneDayTime = 24*60*60*1000;
            const mondayTime = nowTime - (day-2)*oneDayTime;//默认是周二
            this.v_week =this.$moment(new Date(mondayTime)).format('YYYY-MM-DD')
            this.newDateWeekHandle()
        },
 
        attView(row){
            this.FILEPATH =row['imgpath']
            this.FILEPATH2 =row['imgpath2']
            this.FILEPATH3 =row['imgpath3']
            this.FILEPATH4 =row['imgpath4']  
            this.showWin =true
        },
        customColorMethod(val) {
            if (val =='NO' ||val=='PEND') { //未开始，进行中
                return 'info';
            } else if (val =='OK') {
                return 'success';
            } else {
                return 'danger';
            }
        },
        headStyle({row,column}){
            if (column.property=='jobdesc' ){
                return 'color:red;height:26px'
            }
        },
        //图片预览
        imgPreview(path){
            if (path &&path.lastIndexOf('.pdf')>-1){
                let routeUrl = this.$router.resolve({
                    path: '/fullPreview',
                    query: {fileUrl: path},
                });
                window.open(routeUrl.href, '_blank');
            } 
        },
        //图片删除，操作数组
        imgDel(row, index){
            this.$confirm('你确定要删除此记录吗?','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                this.delPath.push({IDSEQ:row['IDSEQ'],LSTSEQ:row['LSTSEQ'],FILEPATH:row['FILEPATH'],PATH:row['PATH']}) 
                this.attData.splice(index, 1)   
            }).catch(()=>{})
        },
        //上传显示进度
        handleProgress(event,file,fileList){
            this.videoFlag = true
            this.videoUploadPercent = Math.floor(event.percent)
        },
        handleFormatError (file) {
            this.promptWin =true
            this.prompt='文件格式错误,'+file.name + ' 是不正确, 请选择图片或PDF格式或office或dxf'
        },
        //文件超出指定文件大小限制的钩子
        handleMaxSize (file) {
            this.promptWin =true
            this.prompt=file.name + ' 文件太大, 不能超出10M' 
        },
 
        // 文件上传成功时的钩子
        successImgFile(res,file){
            this.videoUploadPercent=0 
            this.videoFlag = false
            if (res.code=='200'){
                this.attData.splice(this.v_imgIndex,1,Object.assign(this.v_imgRow,{FILEPATH:this.$store.state.nasUrl+res.result,FILENM:file.name, PATH:'/web/web_images/material/'+res.result }))                   
            }else{0
                this.promptWin =true
                this.prompt =res.result
            }   
        },
        beforeImgFile (file) {
            const extension =file.name.split('.').pop().toLowerCase()
            //禁止上传的类型
            const forbiddenType=['exe','dmg']
            if (forbiddenType.includes(extension)){
                this.promptWin =true
                this.prompt ='exe 与 dmg 不能上传'
                return false //阻止上传
            }else{
                this.fileName= getDate('year')+'-plan'     
                this.uploadData = {
                    code: this.fileName ,
                    p_type:'IMG',
                    p_path:'/web/web_images/material/',
                    p_user:this.v_username
                }
                let promise = new Promise(resolve => {
                this.$nextTick(function() {
                        resolve(true);
                    });
                });
                return promise;
            }
        },
        //禁止 键盘上、下键改变值
        showkey() {
            document.onkeydown = function () {
                if (window.event.keyCode === 38 || window.event.keyCode === 40) {
                    window.event.returnValue = false;
                }
            }
        },
        oneSure(obj){
            if (this.v_key =='SUPNM'){
                Object.assign(this.perRow,{ SUPNO:obj['IDNO'],SUPNM:obj['SUPNM']} )  
            }else if (this.v_key =='FRSUPNO'){
                Object.assign(this.v_nodeRow,{ FRSUPIDSEQ:obj['IDSEQ'],FRSUPNO:obj['SUPNM']} )  
            }else if (this.v_key =='228813' ) { //销售订单
        
                Object.assign(this.perRow,{ REFIDNO:obj['IDNO'] } ) 
            }else{
                Object.assign(this.perRow,{ PARENTNO:obj['IDNO']} )  
            }
           this.oneWin =false
        },
        tyClear(){
           this.perRow ['REFIDNO']=''     
        },
        btnSure(obj){
            if (this.v_key =='MATNO'){
                let v_matno ='',v_matnm=''           
                obj.forEach(item=>{
                    if (v_matno){
                        v_matno=v_matno+','+item['IDNO']
                        v_matnm=v_matnm+','+item['MATNM']
                    }else{
                        v_matno =item['IDNO']
                        v_matnm =item['MATNM']
                    }
                })
                Object.assign(this.perRow,{ MATNO:v_matno,MATNM: v_matnm} ) 
            }else if (this.v_key =='REFWKNO'){
                let v_wkno =''          
                obj.forEach(item=>{
                    if (v_wkno){
                        v_wkno=v_wkno+','+item['IDNO']
                    }else{
                        v_wkno =item['IDNO']
                    }
                })
                Object.assign(this.perRow,{ REFWKNO: v_wkno} ) 
            }else if (this.v_key =='STAFF'){
                let v_staff ='' ,v_telno=''     
                obj.forEach(item=>{
                    if (v_staff){
                        v_staff=v_staff+','+item['EMPNM']
                        v_telno =v_telno+','+ item['TELNO']
                    }else{
                        v_staff =item['EMPNM']
                        v_telno =item['TELNO']
                    }
                })
                Object.assign(this.v_nodeRow,{ STAFF: v_staff, STAFF_NO:v_telno} ) 
            }else if (this.v_key =='228814' || this.v_key =='451336' ) { //采购订单、开发建议书
                let v_idno ='' 
                obj.forEach(item=>{
                    if (v_idno){
                        v_idno=v_idno+','+item['IDNO']
                    }else{
                        v_idno =item['IDNO']
                    }
                })
                Object.assign(this.perRow,{ REFIDNO:v_idno } ) 
            }
            this.btnWin =false
        },
        clrBtn( key){
          if (key =='matno') { 
             this.perRow['MATNM'] =''
          }else if (key =='parentno') { 
             this.perRow['PARENTNO'] =''
          }else if (key =='SUPNM') { 
             this.perRow['SUPNM'] =''
             this.perRow['SUPNO'] =''
          }else if (key =='FRSUPNO') { 
             this.v_nodeRow['FRSUPNO'] =''
          }
        },
        inputBtn( key){         
            this.v_random=Math.random()   
            if (key =='MATNO'){ //物料
                this.v_key =key  
                this.v_table ='v_bs_mat'
                this.tableCol =this.prodCol
                this.v_key2 =''
                this.v_value2 =''
                this.v_cond=' and modelno in (\'PRD\',\'MIX\')'
                this.btnWin =true
            }else if (key =='PARENTNO'){ //父级任务单
                this.v_key =key  
                this.v_table ='v_bs_plan'
                this.v_Col =this.oneCol
                this.v_key2 =''
                this.v_value2 =''
                this.oneWin =true
            }else if (key =='SUPNM'||key=='FRSUPNO'){ //供应商
                this.v_key =key  
                this.v_table ='v_bs_sup'
                this.v_Col =this.supCol
                this.v_key2 =''
                this.v_value2 =''
                this.oneWin =true
            }else if (key =='REFWKNO'){ //关联任务单号
                this.v_key =key  
                this.v_table ='v_bs_plan'
                this.tableCol =this.tabArr
                this.v_key2 =''
                this.v_value2 =''
                this.v_cond=''
                this.btnWin =true
            }else if (key =='STAFF'){ //关联业务负责人
                this.v_key =key  
                this.v_table ='V_HR_EMP_STFG'
                this.tableCol =this.empCol
                this.v_key2 ='isout'
                this.v_value2 ='N'
                this.v_cond=''
                this.btnWin =true
            }else {
                if (this.perRow['REFIDTY']) {
                    if (this.perRow['REFIDTY']=='228814') { //采购订单
                        this.v_key ='228814'  
                        this.v_table ='v_po_ord'
                        this.tableCol =this.poCol
                        this.v_key2 =''
                        this.v_value2 =''
                        this.v_cond=''
                        this.btnWin =true
                    }else if (this.perRow['REFIDTY']=='228813') { //销售订单
                        this.v_key ='228813' 
                        this.v_table ='v_ord'
                        this.v_Col =this.ordCol
                        this.v_key2 ='isfin'
                        this.v_value2 ='N'
                        this.v_cond=''
                        this.oneWin =true
                    }else if (this.perRow['REFIDTY']=='451336') { //开发建议书
                        this.v_key ='451336' 
                        this.v_table ='v_RD_MAT'
                        this.tableCol =this.newCol
                        this.v_key2 =''
                        this.v_value2 =''
                        this.v_cond=''
                        this.btnWin =true
                    }else if (this.perRow['REFIDTY']=='487443') { //品质异常通知单
                        this.v_key ='451336' 
                        this.v_table ='v_qc_bad'
                        this.tableCol =this.qcCol
                        this.v_key2 =''
                        this.v_value2 =''
                        this.v_cond=''
                        this.btnWin =true
                    }  
                }else{
                    this.promptWin =true
                    this.prompt ='请选择单据类型'
                }
            }
            // this.$nextTick(()=>{
            //     this.$refs['refpub'].v_row={}
            // })
        },
 
        //保存记录
        saveRec(){
            var vm =this 
            this.notNull.some(item=>{  //forEach 没找到跳出循环，some：return true 跳出lop ,every：return false 跳出
                if (!this.perRow[item.FLDNO] ){
                    this.stfgBool =false 
                    this.promptWin=true
                    this.prompt=item.FLDNM+'不能为空'
                    return true
                }else{
                    this.stfgBool =true  
                }
            })
            console.log('refidno:',(this.perRow['REFIDNO']==null|| this.perRow['REFIDNO']=='') )
            if (this.perRow['TASKTY']=='414831' && this.perRow['REFIDTY']!=='228813' && (this.perRow['PARENTNO']==null|| this.perRow['PARENTNO']=='') ){
                //this.perRow['REFIDNO'] 
                this.stfgBool =false 
                this.promptWin=true
                this.prompt='类型为订单时，关联单据类型要为销售订单 '
                return
            }if (this.perRow['TASKTY']=='414831' && this.perRow['REFIDTY']=='228813' && (this.perRow['REFIDNO']==null|| this.perRow['REFIDNO']=='')){
                this.stfgBool =false 
                this.promptWin=true
                this.prompt=' 单据类型为销售订单时关联单据号不能为空'
                return
            }
            //发起保存请求   
            if (this.stfgBool && this.v_saveFlag) {  
                if (this.perRow['IDNO']&&this.perRow['IDNO']==this.perRow['PARENTNO']){
                    this.promptWin =true
                    this.prompt ='任务单号与父级任务单号不能相同'
                }else{
                    let obj_ ={CORPID:this.v_corpid,IDSEQ:this.perRow['IDSEQ'],FINDTTM:this.perRow['TODTTM'],STFG:this.perRow['STFG'],PCT:this.perRow['PCT'],SUPNM:this.perRow['SUPNM']
                        ,MATNM:this.perRow['JOBDESC'],PARAM:this.perRow['PMRMK'],EMPNO:this.perRow['EMPNO1'],EMPNO2:this.perRow['EMPNO2'],EMPNO3:this.perRow['EMPNO3']}      
                    Object.assign(obj_,vm.perRow,{ 'CORPID':this.v_corpid }) 
                    if (this.perRow['IDNO'] && this.perRow['IDNO'].substring(0,1)=='K'){
                        this.$axios({
                            method: 'post',
                            url:'xuper_auth/formOneSave',
                            data: {p_json:JSON.stringify(obj_), p_table:'rd_mat',frmid:'417247'},
                        }).then(res=>{      
                            if(res.result ==='OK')  {      
                                this.v_saveFlag =false
                                vm.drawer =false   
                                vm.qryTabData()
                            }else{
                                this.promptWin=true
                                this.prompt=res.result
                            }        
                        }) 
                    }else{
                        this.$axios({
                            method: 'post',
                            url:'xuper_auth/formOneSave',
                            data: {p_json:JSON.stringify(obj_), p_table:'bs_plan',frmid:'407458'},
                        }).then(res=>{                               
                            if(res.code ==='200') {  
                                let v_idseq =res.idseq
                                this.$axios({   
                                    method: 'post',
                                    url:'xuper_auth/batDtlSave2',
                                    data: {p_json:JSON.stringify(this.attData), p_table:'MAT_IMG',p_idseq:v_idseq,p_action:'S' },
                                })
                                //删除服务器上的真实附件   
                                for(let k=0;k<this.delPath.length;k++){
                                    let v_filepath=this.delPath[k]['FILEPATH'],v_path=this.delPath[k]['PATH']
                                    this.$axios({
                                        method: 'post',
                                        url:'xuper_auth/delTabRec',
                                        data: {p_key:'idseq',p_value:this.delPath[k]['IDSEQ'],p_key2:'lstseq',p_value2:this.delPath[k]['LSTSEQ'],p_key5:'filepath',p_value5:this.delPath[k]['FILEPATH'],p_table:'mat_IMG'},
                                    }).then(res=>{          
                                        //删除群晖上的文件 ,如果 是重复文件上传时 v_path 是空的，这时是不要删除真正的文件
                                        if (v_filepath.indexOf('https://')>-1 && v_filepath && v_path){
                                            this.$axios({
                                                method: 'post',
                                                url: '/xuper_oss/ftpDelete',
                                                data: {p_path:'/volume1'+v_path},
                                            }).then(res=>{ 
                                                console.log(res.result)
                                            })
                                        }
                                            
                                    })        
                                }   
                                this.v_saveFlag =false
                                vm.drawer =false   
                                vm.qryTabData()
                            }else{
                                this.promptWin=true
                                this.prompt=res.result
                            }        
                        }) 
                    }
                }
            }
        },
        // 截断字符串
        truncate(text, length) {
        if (!text) return "";
            return text.length > length ? text.slice(0, Math.floor(length)) + "..." : text;
        },
        //工作明细
        getWkList(cond){
            this.t_loading =true
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getPlanTreeData',
                data: {p_key:'corpid',p_value:this.v_corpid,p_table:'V_bs_plan',p_cond:cond+' order by lvl desc' },
            }).then(res=>{ 
                if (res.code==='200'){
                    this.tabData =res.result
                    this.dtlData =[]
                    if (this.tabData.length>0){
                        this.$nextTick(() => { //有固定列时 查询后重新布局
                            this.$refs['tabref'].setCurrentRow(this.tabData[this.v_index])
                            this.t_loading =false
                            this.t_idseq =this.tabData[this.v_index]['idseq']
                            this.getdtlData(this.tabData[this.v_index]['idseq'])
                        })
                    }else{
                        this.t_loading =false
                    }
                }else{
                    this.promptWin=true
                    this.prompt=res.result
                }   
            }) 
        },
        //查询明细数据
        getdtlData(idseq){
            this.dtlData=[]
            this.v_loading=true
            getTabColOrData(this.v_url,'V_bs_plandtl','idseq',idseq,'','','','',' order by adddttm desc').then((res) => {               
                this.dtlData =res.result  
                this.$nextTick(()=>{
                    this.$refs['reflog'].doLayout()
                    this.v_loading=false
                })
                this.getNodeData(idseq)
            })
        },
        getNodeData(idseq){
            this.nodeData=[]
            getTabColOrData(this.v_url,'V_BS_PLAN_ITEM','idseq',idseq,'','','','',' order by adddttm ').then((res) => {               
                this.nodeData =res.result  
                this.$nextTick(()=>{
                    this.$refs['refnode'].doLayout()
                })
            })
        },
        editRec(row,index,val){
            this.v_index =index
            this.t_idseq =row['idseq']
            if (val==='Y'){  //仅查看
                this.saveFlag=true
            }else{
                if (row.ordstfg=='OK'){
                    this.saveFlag=true
                }else{
                    if (this.v_admin=='Y'|| row['adduser']==this.v_usernm ||row['empno']==this.v_username||row['empno2']==this.v_username||row['empno3']==this.v_username||row['empno4']==this.v_username||row['empno5']==this.v_username ){
                        this.saveFlag =false
                    }else{
                        this.saveFlag =true
                    }
                }
            }
            this.v_saveFlag =true
            //this.perRow =JSON.parse(JSON.stringify(row))
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'idseq', p_value:row['idseq'],  p_table:'V_bs_plan'},
            }).then(res=>{
                if (res.code=='200'){
                    this.perRow =JSON.parse(JSON.stringify(res.result[0]))
                }else{
                    this.promptWin =true
                    this.prompt =res.result
                }
            })
            if (row['taskty']=='414833'){ //为研发时不能保存
                this.v_action ='Y'                
            }else{
                this.v_action ='N'
            }
            this.qryImgData(row['idseq'])
            this.drawer=true   
            this.FILEPATH =row['imgpath']
            this.FILEPATH2 =row['imgpath2']
            this.FILEPATH3 =row['imgpath3']
            this.FILEPATH4 =row['imgpath4']   
        },
 
        //查询
        qryTabData(){
            let cond_=''
            if (this.v_frdttm!=='1969-12-29' && this.v_frdttm) {
                cond_ =cond_+' and ((todttm between \''+this.v_frdttm+'\' and \''+this.v_todttm+'\') or (stfg!=\'OK\' and todttm<=\''+this.v_todttm+'\'))'
            }
            if (this.selparam && this.txtparam){ //列1
                if (this.oper==='like'){
                    cond_=cond_+' and upper('+this.selparam+') like upper(\'%' + this.txtparam+'%\')'
                }else{
                    cond_=cond_+' and upper('+this.selparam+')' +this.oper+'upper(\''+this.txtparam+'\')'
                }
            }
            if (this.v_self=='Y') { // 过滤当前用户
                cond_ =cond_+' and (empNO=\''+this.v_username+'\' or empNO2=\''+this.v_username+'\' or empNO3=\''+this.v_username+'\' or empNO4=\''+this.v_username+'\' or empNO5=\''+this.v_username+'\')'
            } 
            if (this.v_status){ //进度状态
                if (this.v_status =='NOTOK'){
                    cond_=cond_+' and WKstfg!=\'OK\'' 
                }else{
                    cond_=cond_+' and stfg=\''+this.v_status+'\' '
                }
            }
            //console.log(cond_)
            this.getWkList(cond_)
        },
        //新增 
        addRec(){
            this.drawer =true
            this.stfgCss='icon-weishenhe3'
            this.perRow={STFG:'NO',PARENTNO:'',LVL:75}      //,TASKTY:'414831'
            this.saveFlag=false
            this.v_saveFlag =true
        },
        addSub(row ,index){
            this.drawer =true
            this.stfgCss='icon-weishenhe3'
            this.perRow={STFG:'NO', PARENTNO:row['idno']}      
            this.saveFlag=false
            this.v_saveFlag =true
        },
        //获取表列字段
        getTabField(){
            let vm =this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','407458','lstseq','4','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.tabArr.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key.toLowerCase(),
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        sortable:res.result[k].SORTABLE,
                    })
                    vm.oneCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key.toUpperCase(),
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        sortable:res.result[k].SORTABLE,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','407458','lstseq','3','','',' order by sortby,itmseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.dtlCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','4272','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.prodCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss:res.result[k].EDCSS,
                        sortable:res.result[k].SORTABLE,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        disabled:res.result[k].DISABLED,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','108','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.poCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','123','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.ordCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                    })
                }
            })            
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','412740','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.qcCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','417247','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.newCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','100','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.supCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        sortable:res.result[k].SORTABLE,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','440642','lstseq','6','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.attCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        sortable:res.result[k].SORTABLE,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','407458','lstseq','6','','',' order by sortby,itmseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.nodeCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','4204','lstseq','4','','',' order by sortby,itmseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.empCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                    })
                }
            })
        }
    }
}
</script>
<style scoped lang="less">
    .active { 
        color: #389 !important;
        border-bottom:2px solid #cc0000;
        margin-right:2px;
    }
    .tabact { 
        color: #f00 !important;
        border-bottom:2px solid #cc0000;
        margin-right:2px;
    }
    .oneMenu{
        display:flex;
        flex-direction:column;
        line-height:25px;
        background:white;
        margin-top:3px;
        font-size:13px;
        font-weight: 600;
    }
    .oneMenu:hover{
        cursor: pointer;
        color:#cc0000;
        background:#f7f8f9;
        font-weight:700;
    }
 
    .top{
        padding: 10px;
        background: rgba(0, 153, 229);
        color: #fff;
        text-align: center;
        font-size:10px;
        border-radius: 2px;
    }  
 
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 1px auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
    .item-width  {
        width: 48%;
        color:#409EFF;
 
    }
    .item-width2  {
        width: 98%;
        height:60px;
    }
    .active { 
        color:#D200D2; 
    } 
 
</style>
<style lang="less">
    .el-icon-arrow-right {
        color:#ff0000;
    }
    .el-table .el-table__expand-icon{
        .el-icon-arrow-right:before{
            content: '\e791';
        }
    }
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table .gray-row  {
        color: #808080;
    }
    .el-table .blue-row  {
        color: blue;
    }
    .el-table .red-row  {
        color: red;
    }.el-table .green-row  {
        color: green;
    }.el-table .black-row  {
        color: black;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 5px ;
            font-size:11px;
        }   
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    // .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
 
</style>
 